<template>
  <div class="e2e-upload-container">
    <div class="label-box">
      <div v-if="label" class="label-item">
        <span class="label-text">{{ label || '&nbsp;' }}</span>
      </div>
      <SingleUpload
        class="upload-item"
        :action="action"
        :multiple="false"
        :accept="accept"
        :maxFileSize="maxFileSize"
        :disabled="disabled || fileList.length == 0"
        v-if="
          !disabled &&
          localFileList.length !== 0 &&
          localFileList.length < limit
        "
        :autoUpload="autoUpload"
        :params="params"
        :change="onChange"
        :success="onSuccess"
        :error="onError"
        :beforeUpload="beforeUpload"
      >
        <i
          class="gsk-icon-clip"
          style="font-size: 16px; color: #000"
          aria-hidden="true"
        ></i>
        <span class="btn-add-text">{{ $t('btn.add') }}</span>
      </SingleUpload>
    </div>
    <div
      class="label-item"
      v-if="subLabel"
      style="
        font-size: 12px;
        white-space: normal;
        color: #666;
        margin-bottom: 10px;
      "
    >
      <span class="label-text">{{ subLabel || ' ' }}</span>
    </div>
    <div class="file-box" v-if="localFileList.length != 0">
      <el-checkbox-group v-model="checkedFilesList" @change="handleCheckFile">
        <template v-for="(lineFileList, lineIndex) in forEachFileList">
          <div class="line-file-box" :key="lineIndex">
            <template v-for="(file, fileIndex) in lineFileList">
              <el-checkbox
                v-if="select"
                :label="typeof file.id == 'object' ? file.id.id : file.id"
                :key="fileIndex"
                :class="{ 'empty-file-item': !(file.name || file.fileName) }"
                :disabled="file.disableCheck">
              </el-checkbox>
              <div :key="fileIndex" v-if="!(file.name || file.fileName)&&select" style="width: 24px;"></div>
              <div
                class="file-item"
                :class="{ 'empty-file-item': !(file.name || file.fileName) }"
                :key="fileIndex"
              >
                <template v-if="file.fileName || file.name">
                  <div class="file-type-box">
                    <i
                      :class="icon || getIconByFileName(file)"
                      @click="preview ? previewFile(file) : () => {}"
                      :style="
                        preview
                          ? 'font-size: 40px;cursor: pointer;'
                          : 'font-size: 40px;'
                      "
                    ></i>
                  </div>
                  <div class="file-action-box">
                    <div
                      class="line"
                      style="display: flex; justify-content: space-between"
                    >
                      <span
                        :title="file.name || file.fileName"
                        @click="preview ? previewFile(file) : () => {}"
                        class="line-file-name"
                        >{{ file.name || file.fileName }}</span>
                      <span
                        v-show="!disabledDelete && allowDelete(file)"
                        @click="delFile(file)"
                        class="line-file-delete"
                        >{{ $t('btn.delete') }}</span>
                    </div>
                    <div
                      class="line"
                      style="display: flex; justify-content: space-between"
                    >
                      <div style="display: flex; justify-content: space-between">
                        <span>{{
                          (file.size || file.fileSize) | FileSizeFormat
                        }}</span>
                        <span
                          v-if="showDate"
                          style="margin-left: 5px"
                          v-text="showDatePage(file)"
                        ></span>
                      </div>
                      <div style="display: flex; justify-content: space-between">
                        <span
                          v-if="preview"
                          @click="previewFile(file)"
                          class="line-file-preview"
                        >{{ $t('btn.preview') }}</span>
                        <span
                          v-if="download"
                          @click="downloadFile(file)"
                          class="line-file-download"
                          >{{ $t('btn.download') }}</span>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </template>
          </div>
        </template>
      </el-checkbox-group>
    </div>
    <div class="empty-box" v-else>
      <NoDataFound>
        <div
          class="empty-upload"
          style="font-size: 14px; color: #999; text-align: center"
        >
          <SingleUpload
            v-if="!disabled"
            :action="action"
            :multiple="false"
            :accept="accept"
            :maxFileSize="maxFileSize"
            :disabled="disabled"
            :autoUpload="autoUpload"
            :params="params"
            :change="onChange"
            :success="onSuccess"
            :error="onError"
            :beforeUpload="beforeUpload"
          >
            <span>{{
              $languageChoose({
                en:
                  'Only support ' +
                  (forEachAccept || 'files') +
                  ' within ' +
                  maxFileSize +
                  'M,',
                zh: '仅支持' + maxFileSize + 'M内的' + forEachAccept + '文件，'
              })
            }}</span>
            <span style="color: #f36633">{{ $t('btn.add') }}</span>
          </SingleUpload>
        </div>
      </NoDataFound>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import axios from '@/util/axios';
import SingleUpload from './SingleUpload';
import NoDataFound from '@/components/common/NoDataFound';
import { E2E_FILE_TYPE_ENUM, File_Type_Name_Mapping } from '@/constant/common';

export default {
  data() {
    return {
      keyId: 0,
      localFileList: [],
      checkedFilesList: []
    };
  },
  props: {
    fileList: {
      // 文件列表
      type: Array,
      default: () => {
        return [];
      },
      required: true
    },
    label: {
      // 显示的标题
      type: String
    },
    subLabel: {
      // 显示的标题
      type: String
    },
    action: {
      type: String, // 上传地址,自动上传时需要
      default: ''
    },
    params: {}, // 自动上传文件时需要传递的form
    accept: {
      type: String, // 接受上传的文件类型 ex: .pdf,.png, 全部类型为 '*'
      default: '*'
    },
    maxFileSize: {
      type: Number, // 最大上传文件大小，单位为 M
      default: 30
    },
    disabled: {
      type: Boolean, // 是否禁止上传
      default: false
    },
    disabledDelete: {
      type: Boolean, // 是否禁止删除
      default: false
    },
    download: {
      type: Boolean, // 是否允许下载
      default: false
    },
    preview: {
      type: Boolean, // 是否允许预览
      default: true
    },
    autoUpload: {
      type: Boolean, // 是否自动上传
      default: true
    },
    limit: {
      // 最大允许上传个数
      type: Number,
      default: 10000
    },
    success: {
      // 成功的回调函数,用于自动上传
      type: Function
    },
    error: {
      // 失败的回调函数,用于自动上传
      type: Function
    },
    selectChange: {
      // 选中的回调函数,用于自动上传
      type: Function
    },
    change: {
      // change的回调函数,用于手动上传
      type: Function
    },
    deleteFile: {
      // 删除文件的事件， need return promise, 传递 file 参数
      type: Function
    },
    lineNum: {
      type: Number,
      default: 3
    }, // 单行显示的文件数量
    icon: {
      // 文件前显示的 icon 图标样式
      type: String
    },
    deleteMode: {
      // 删除模式 add: 只能增加，不能删除历史的数据， write: 可以修改所有文件
      type: String,
      default: 'write'
    },
    fullS3Path: {
      type: String,
      default: ''
    },
    showDate: {
      type: Boolean,
      default: false
    },
    isHco: {
      type: Boolean,
      default: false
    },
    select: {
      type: Boolean,
      default: false
    },
    selectedFileList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    downloadFun: {
      type: Function
    }
  },
  model: {
    props: 'value',
    event: 'changeFile'
  },
  components: {
    SingleUpload,
    NoDataFound
  },
  computed: {
    forEachFileList: function() {
      const list = [];
      let tmpArr = [];
      this.localFileList.map((item, index) => {
        tmpArr.push(item);
        if (tmpArr.length % this.lineNum == 0) {
          list.push(tmpArr);
          tmpArr = [];
        }
        if (this.localFileList.length == index + 1) {
          if (tmpArr.length > 0) {
            // 如果小于当前需要显示的数量，使用空的 div 进行数量补齐，否则 flex space-between 会产生两端对齐的样式
            if (tmpArr.length < this.lineNum) {
              const emplyFile = {};
              const sub = this.lineNum - tmpArr.length;
              for (let i = 0; i < sub; i++) {
                tmpArr.push(emplyFile);
              }
            }
            list.push(tmpArr);
          }
        }
      });
      return list;
    },
    // accept 显示的信息获取
    forEachAccept() {
      const accepts = this.accept.split(',');
      const acceptArray = [];
      accepts.map((acceptItem, acceptIndex) => {
        const localAccept = acceptItem.trim().toLowerCase();
        if (File_Type_Name_Mapping[localAccept]) {
          acceptArray.push(
            this.$languageChoose(File_Type_Name_Mapping[localAccept])
          );
        }
      });
      return acceptArray.join('/');
    }
  },
  methods: {
    // 通知父组件更新 文件列表
    updateParentFileList() {
      this.$emit('update:fileList', this.localFileList);
      this.$emit('update:selectedFileList', this.checkedFilesList);
    },
    beforeUpload(file) {
      if (this.limit <= this.localFileList.length) {
        this.$message({
          type: 'error',
          message:
            this.$t('component.filebox.limit_prefix') +
            `${this.limit}` +
            this.$t('component.filebox.limit_suffix') +
            (this.localFileList.length > 1
              ? this.$t('system.plural_suffix')
              : '')
        });
        return false;
      }
      return true;
    },
    onChange(file) {
      if (!this.autoUpload) {
        this.localFileList.push(file);
        this.updateParentFileList();
      }
      if (this.change) {
        this.change(file);
      }
    },
    onSuccess(file) {
      this.localFileList.push(file);
      this.updateParentFileList();
      if (this.success) {
        this.success(file);
      }
    },
    onError(err, file) {
      if (this.error) {
        this.error(err, file);
      }
    },
    delFile(file) {
      const index = this.localFileList.indexOf(file);
      const id = typeof file.id == 'object' ? file.id.id : file.id;
      const { checkedFilesList } = this;
      if (checkedFilesList.length > 0) {
        checkedFilesList.forEach((x, i) => {
          const checkedId = typeof x.id == 'object' ? x.id.id : x.id;
          if (checkedId === id || checkedId === id) {
            this.checkedFilesList.splice(i, 1);
          }
        });
      }
      this.$messageBox({
        icon: 'warning', // --->弹窗类型 非必填 [success √,warning ！,error X]
        severity: 'high', // --->危险等级 非必填  [low 蓝,medium 黄,high 红]
        title: this.$t('component.filebox.confirm_delete_file'), // --->主标题 必填
        btnText: this.$t('btn.confirm'), // -->按钮内文字 非必填
        callBack: () => {
          if (index >= 0) {
            if (file.id) {
              let p = this.deleteFile
                ? this.deleteFile(file)
                : Promise.resolve();
              if (!p) {
                console.error('deleteFile need return a promise');
                p = Promise.resolve();
              }
              p.then((res) => {
                this.localFileList.splice(index, 1);
                this.updateParentFileList();
                this.$emit('afterDelete');
              });
            } else if (this.isHco) {
              let p = this.deleteFile
                ? this.deleteFile(file)
                : Promise.resolve();
              if (!p) {
                console.error('deleteFile need return a promise');
                p = Promise.resolve();
              }
              p.then((res) => {
                this.localFileList.splice(index, 1);
                this.updateParentFileList();
              });
            } else {
              // 没有文件id 说明为本地上传的文件，删除本地上传文件不需要发送请求
              this.localFileList.splice(index, 1);
              this.updateParentFileList();
              //  this.$emit('foreupdate');
            }
          } else {
          }
        } // -->点击按钮后回调函数 非必填
      });
    },
    getFileTypeByFilename(fileName) {
      let fileType = '';
      const nameParts = fileName.split('.');
      const suffix = nameParts[nameParts.length - 1].toLowerCase();
      for (const typeKey in E2E_FILE_TYPE_ENUM) {
        E2E_FILE_TYPE_ENUM[typeKey].map((item, index) => {
          if (item === suffix) {
            fileType = typeKey;
          }
        });
      }
      return fileType;
    },
    onlinePreview(file) {
      let url = `${location.origin}/static/file/${file.fileS3Path}`
      console.log(url)
      return axios({
        url: url,
        // url: '/static/file/manual.pdf',
        method: 'GET',
        responseType: 'arraybuffer'
      });
    },
    // 是否允许删除, deleteMode 为add 只有新上传的文件可以删除，deleteMode 为 write 则所有文件可以删除
    // fileSize 文件的 fileSize 属性存在代表该文件为历史文件
    allowDelete(file) {
      let allow = true;
      if (this.deleteMode == 'add' && file && file.status === '1') {
        allow = false;
      }
      return allow;
    },
    // 显示日期
    showDatePage(file) {
      let date = '';
      if (!file) {
        return;
      }
      if (file.updateTime) {
        date = file.updateTime.replace(/-/g, '/').split(' ')[0];
      } else if (file.createTime) {
        date = file.createTime.replace(/-/g, '/').split(' ')[0];
      } else {
        const now = new Date();
        const year = now.getFullYear();
        const month =
          now.getMonth() + 1 < 10
            ? '0' + (now.getMonth() + 1)
            : now.getMonth() + 1;
        const day =
          now.getDate() + 1 < 10 ? '0' + now.getDate() : now.getDate();
        date = `${year}/${month}/${day}`;
      }
      return date;
    },
    async previewFile(file) {
      const filename = file.name || file.fileName;
      const fileType = this.getFileTypeByFilename(filename);
      switch (fileType) {
        case 'pdf':
          let params = {};
          // 如果没有特别指定s3完整地址，就用file数据里的fileS3Path字段
          const fullS3Path =
            this.fullS3Path !== '' ? this.fullS3Path : file.fileS3Path;
          if (fullS3Path) {
            const res = await this.onlinePreview(file);
            params = {
              fileData: res.data,
              title: filename,
              s3Path: fullS3Path
            };
          } else {
            params = {
              fileData: file.raw,
              title: filename
            };
          }
          params = Object.assign(params, {
            download: file.download
          });

          this.$PDFViewer(params);
          break;
        case 'excel':
          if (file.fileS3Path) {
            this.onlinePreview(file).then((res) => {
              this.$previewExcel({
                data: res.data,
                title: filename,
                download: true
              });
            });
          } else {
            this.$previewExcel({
              data: file.raw,
              title: filename,
              download: true
            });
          }
          break;
        case 'image':
          if (file.fileS3Path) {
            this.onlinePreview(file).then((res) => {
              this.$previewImg({
                data: res.data,
                title: filename,
                download: true
              });
            });
          } else {
            this.$previewImg({
              data: file.raw,
              title: filename,
              download: true
            });
          }
          break;
        default:
          this.$message.info(this.$t('component.filebox.not_support_preview'));
          break;
      }
    },
    async downloadFile(file) {
      if (this.downloadFun) {
        this.downloadFun();
      } else {
        const v = this.versions();
        const filename = file.name || file.fileName;
        if (file.fileS3Path) {
          if (v.iPhone || v.iPad) {
            const link = document.createElement('a');
            link.style.display = 'none';
            link.href = file.fileS3Url;
            link.setAttribute('download', file.fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link); // 下载完成移除元素
          } else {
            const res = await this.onlinePreview(file);
            this.$downloadFile(res.data, filename, res.headers['content-type']);
          }
        } else {
          this.$downloadFile(file.raw, filename);
        }
      }
    },
    getIconByFileName(file) {
      let icon = '';
      const filename = file.name || file.fileName;
      const nameParts = filename.split('.');
      const suffix = nameParts[nameParts.length - 1].toLowerCase();
      for (const typeKey in E2E_FILE_TYPE_ENUM) {
        E2E_FILE_TYPE_ENUM[typeKey].map((item, index) => {
          if (item === suffix) {
            icon = `gsk-icon-${typeKey}`;
          }
        });
      }
      return icon || 'gsk-icon-file';
    },
    versions() {
      const u = navigator.userAgent;
      return {
        trident: u.indexOf('Trident') > -1, // IE内核
        presto: u.indexOf('Presto') > -1, // opera内核
        webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, // 火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
        android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, // android终端
        iPhone: u.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
        iPad: u.indexOf('iPad') > -1, // 是否iPad
        webApp: u.indexOf('Safari') == -1, // 是否web应该程序，没有头部与底部
        weixin: u.indexOf('MicroMessenger') > -1, // 是否微信 （2015-01-22新增）
        qq: u.match(/\sQQ/i) == ' qq' // 是否QQ
      };
    },
    handleCheckFile(val) {
      this.updateParentFileList();
      if (this.selectChange) {
        this.selectChange(val);
      }
    }
    // disableCheck(file) {
    //   if (this.checkedFilesList.length > 0) {
    //     const id = typeof file.id == 'object' ? file.id.id : file.id;
    //     const { checkedFilesList } = this;
    //     return checkedFilesList.some(x => x !== id);
    //   } else {
    //     return false;
    //   }
    // }
  },
  watch: {
    fileList: {
      handler(newValue, oldValue) {
        this.localFileList = _.cloneDeep(newValue);
      },
      deep: true
    },
    selectedFileList: function(newValue, oldValue) {
      this.checkedFilesList = _.cloneDeep(newValue);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.localFileList = _.cloneDeep(this.fileList);
      this.checkedFilesList = _.cloneDeep(this.selectedFileList);
    });
  }
};
</script>
<style lang="less" scoped>
.e2e-upload-container {
  .label-box {
    width: 320px;
    white-space: nowrap;
    display: flex;
    justify-content: space-between;
    padding: 0 0 8px 0;
    align-items: center;

    .label-item {
      height: 24px;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 24px;
      letter-spacing: 1px;
    }

    .upload-item {
      height: 24px;
      display: flex;
      align-items: center;

      .btn-add-text {
        // height: px;
        font-size: 12px;
        font-weight: 400;
        color: @mainColor;
        line-height: 16px;
      }

      /deep/ .el-upload {
        height: 100%;
        display: flex;
        align-items: center;
      }
    }
  }

  .file-box {
    .line-file-box {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;

      &:nth-child(1) {
        margin-top: 0;
      }
    }

    .file-item {
      width: 320px;
      box-sizing: border-box;
      padding: 8px 16px 8px 0;
      border-radius: 4px;
      border: 1px solid #ccc;
      display: flex;

      .file-type-box {
        padding: 4px 8px;
        height: 48px;
      }

      .file-action-box {
        height: 48px;
        font-size: 14px;
        flex: 1;
        font-weight: 400;
        color: #999999;
        line-height: 24px;
        letter-spacing: 0px;

        .line {
          height: 24px;
          line-height: 24px;

          .line-file-name {
            max-width: 140px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            cursor: pointer;
          }

          .line-file-delete {
            text-align: right;
            //display: block;
            font-size: 12px;
            font-weight: 400;
            color: #e40030;
            letter-spacing: 0px;
            cursor: pointer;
          }

          .line-file-download,
          .line-file-preview {
            text-align: right;
            //display: block;
            //float: right;
            font-size: 12px;
            font-weight: 400;
            color: #008748;
            letter-spacing: 0px;
            cursor: pointer;
          }

          .line-file-download {
            margin-left: 5px;
          }
        }
      }
    }

    .empty-file-item {
      border: none;
    }
  }
}

.empty-box {
  width: 100%;
  padding: 20px;
  text-align: center;

  .empty-upload {
    /deep/ .e2e-single-upload-container {
      .e2e-single-upload {
        display: block;
      }
    }
  }
}

.el-checkbox {
  margin-right: 0;
  line-height: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 5px;

  /deep/ .el-checkbox__label {
    display: none;
  }

  &.empty-file-item {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// FileBox.vue?5155d027